<template>
    <div>
        <div class="flex-between">
            <el-button class="primary" type="primary" @click="add()">新建</el-button>
            <div class="input_box">
                <input type="text" v-model="queryData.query" @keyup.enter="listByPageFun" placeholder="请输入关键字检索" />
                <span style="cursor: pointer" @click="listByPageFun"><i class="el-icon-search"></i></span>
            </div>
            <!-- el-icon-search -->
        </div>
        <div>
            <el-table
                :header-cell-style="{
                    background: 'rgba(229,244,255,1)',
                    color: '#0077CC',
                    fontWeight: 'bold'
                }"
                align="center"
                header-align="center"
                :data="tableData"
                style="width: 100%"
            >

                <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="name" label="栏目名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="descn" label="栏目描述" header-align="center" width="280" align="center">
                    <template slot-scope="scope"><p class="line-clamp2" :title="scope.row.descn">{{scope.row.descn}}</p></template>
                </el-table-column>
                <el-table-column prop="createUserName" label="创建人" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createDt" label="创建时间" header-align="center" align="center">
                  <template slot-scope="scope">{{scope.row.createDt | timestampToTime}}</template>
                </el-table-column>
                <el-table-column label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button @click="deleteProgramaFun(scope.row.id)" type="text" size="small">删除</el-button>
                        <el-button @click="updataFun(scope.row)" type="text" size="small">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="flex-end">
                 当前 第 {{queryData.currentPage}} 页，共 {{queryData.pages}} 页 {{queryData.total}} 条记录
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.currentPage"
                    :page-size="queryData.pageSize"
                    layout="prev, pager, next, jumper"
                    :total="queryData.total"
                    style="padding: 45px; text-align:right;"
                ></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="60%"
            :close-on-click-modal="false"
            append-to-body
            :before-close="handleClose" >
            <div>
                <el-form
                    :model="ruleForm"
                    hide-required-asterisk
                    :rules="rules"
                    ref="ruleForm"
                    label-width="85px"
                    label-position="left"
                    class="demo-ruleForm"
        
                >
                    <el-form-item label="栏目名称" prop="name" class="block_box">
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="栏目描述" prop="name" class="block_box">
                        <el-input type="textarea" v-model="ruleForm.descn"></el-input>
                    </el-form-item>
                    
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="el-button" @click="handleClose">返 回</button>
                <button class="el-button1" @click="submitForm('ruleForm')">确 定</button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import {
    listByPagePrograma,
    deletePrograma,//删除
    insertPrograma,//新增
    updatePrograma
} from "../../../api/news.js";
// import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name: "breadcrumbList",
    filters:{
        timestampToTime(timestamp) {
            let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            if(!timestamp){
                return '';
            }
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            let D = date.getDate() + ' ';
            let h = date.getHours() + ':';
            let m = date.getMinutes() + ':';
            let s = date.getSeconds();
            return Y + M + D + h + m + s;
        }
    },
    data() {
        return {
          
            tableData: [],
            dialogVisible: false,
            content: "",
            editorOption: {},
            ruleForm: {
                name: "",
                descn:''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入栏目名称",
                        trigger: "blur"
                    }
                ],
                descn: [
                    {
                        required: true,
                        message: "请输入栏目描述",
                        trigger: "blur"
                    }
                ],
            },
            queryData: {
                currentPage: 1, //当前页
                pageSize: 10,
                pages:'',//总页数
                total: 0,
                query: "", //模糊搜索
                state: -1
            },
            title:"",
        };
    },
    methods: {
        add(){
            this.title="新建";
            this.dialogVisible=true;
        },
        handleSizeChange(val) {
              this.queryData.pageSize = val;
              this.listByPageFun();
            //console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            //console.log(val);
              this.queryData.currentPage = val;
            //console.log(this.queryData);
            // this.getuserlist(this.queryData.currentPage,this.queryData.pageSize);
            this.listByPageFun()
            //console.log(`当前页: ${val}`);
        },
        //列表
        listByPageFun() {
            listByPagePrograma({
                currentPage: this.queryData.currentPage,
                pageSize: this.queryData.pageSize,
                query: this.queryData.query
            })
                .then(res => {
                    //console.log(res, "栏目列表==成功");
                    if (res.code == 200) {
                        this.tableData = res.data.list || [];
                        this.queryData.total = res.data.total || 0;
                        this.queryData.pages = res.data.pages || 0;
                        //console.log(this.queryData, "this.queryData");
                        
                    }else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },
        //删除栏目
        deleteProgramaFun(id) {
            let that = this;
            this.$confirm("确定删除该栏目么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                deletePrograma({
                    id: Number(id)
                }).then(res => {
                    if (res.code == 200) {
                        that.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.listByPageFun();
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                });
                
            }).catch(err => {
                //console.log(err,'错误');
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });
            
        },

        updataFun(row){
            this.title="编辑";

             this.ruleForm= {
                name: row.name,
                descn:row.descn,
                id:row.id
            };
            this.dialogVisible=true;
        },

        //新增栏目
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if(!this.ruleForm.id){
                        insertPrograma(this.ruleForm)
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: "新增成功",
                                    type: "success"
                                });
                                this.$refs[formName].resetFields();
                                this.ruleForm= {
                                        name: "",
                                        descn:''
                                    };
                                this.listByPageFun();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                    }else{
                        updatePrograma(this.ruleForm)
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: "修改成功",
                                    type: "success"
                                });
                                this.$refs[formName].resetFields();
                                this.ruleForm= {
                                        name: "",
                                        descn:''
                                    };
                                this.listByPageFun();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                    }
                    //   
                    this.dialogVisible = false;
                } else {
                    //console.log("error submit!!");
                    return false;
                }
            });
        },

        handleClose(done) {
            this.$refs['ruleForm'].resetFields();
            this.ruleForm= {
                name: "",
                descn:''
            };
            this.dialogVisible = false
        },

    },
    mounted() {},
    created() {
        this.listByPageFun();
    },
    
    computed: {
        // editor() {
        //     return this.$refs.myQuillEditor.quill;
        // }
    }
};
</script>

<style lang="less" scoped>
.el-table {
    margin-top: 20px;
    /deep/ th .cell {
        font-weight: bold;
    }
    .el-button--text {
        color: #197cda;
    }
    .ql-editor {
        min-height: 150px;
    }
}
.flex-end {
    display: flex;
    justify-content: flex-end;
    color: #999999;
    font-size: 14px;
    align-items: center;
    margin-top: 30px;
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
/deep/ .dialog-footer {
        .el-button {
            width: 80px;
            height: 30px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(0, 145, 255, 1);
            box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
            border-radius: 4px;
            padding: 0;
            color:#0091FF;

        }
        .el-button1{
            width:80px;
            height:30px;
            background:rgba(0,126,255,1);
            border:1px solid rgba(0,145,255,1);
            box-shadow:0px 1px 3px 0px rgba(0,72,128,0.3);
            border-radius:4px;
            color: #fff;
            margin-left: 10px;
        }
    }
.primary {
    width: 80px;
    height: 30px;
    background: rgba(0, 145, 255, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
    border-radius: 4px;
    padding: 0;
}
.input_box {
    width: 300px;
    height: 36px;
    border: 1px solid rgba(153, 194, 255, 1);
    border-radius: 4px;
    input {
        width: 270px;
        height: 36px;
        line-height: 36px;
        font-style: italic;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
</style>
